import { render, staticRenderFns } from "./parallax.vue?vue&type=template&id=c8911482&scoped=true&"
import script from "./parallax.vue?vue&type=script&lang=js&"
export * from "./parallax.vue?vue&type=script&lang=js&"
import style0 from "./parallax.vue?vue&type=style&index=0&id=c8911482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8911482",
  null
  
)

export default component.exports